import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Sms from './Sms';
import Messages from './Messages';

const useStyles = makeStyles((theme) => ({
  commentsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Comments = () => {
  const classes = useStyles();

  return (
    <div className={classes.commentsContainer}>
      <Messages />
      <Sms />
    </div>
  );
};

export default Comments;
